import { getFunctions, httpsCallable } from "firebase/functions";

export const sendEmail = async (data) => {
  const functions = getFunctions();
  const callable = httpsCallable(functions, "sendEmail");

  // Generate a unique requestId using crypto.randomUUID()
  data.requestId = crypto.randomUUID();

  try {
    const result = await callable(data);
    return result.data;
  } catch (error) {
    console.error("Error calling sendEmail endpoint:", error);
    throw error; // Rethrow for handling in the calling component/page
  }
};